import Image from 'next/image';
import loader2 from '/public/assets/loader2.gif';
const HomeLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-200 dark:bg-gray-700">
      <Image src={loader2} alt="loader2" className="w-52 md:w-80" />
    </div>
  );
};

export default HomeLoader;
